export const Loading = () => {
    return <div>Authentication in progress...</div>
}